import "./RadioButton.scss";

import React, { Component } from "react";
import clsx from "clsx";

import Text from "../../common/Text/Text";

class RadioButton extends Component {
	render() {
		const { onChange, value, defaultValue, label, id, options, className } =
			this.props;

		const computedValue = value === undefined ? defaultValue : value;

		return (
			<div className={clsx("RadioButton__wrapper", className)}>
				{label && <p className={"RadioButton__label"}>{label}</p>}
				{options.map((opt, index) => (
					<div key={opt.id || index} className={"RadioButton__input-wrapper"}>
						<input
							className={"RadioButton__input"}
							type={"radio"}
							name={id}
							id={`${id}_${index}`}
							value={opt.value}
							checked={computedValue === opt.value}
							onChange={onChange}
						/>
						<Text
							tag={"label"}
							className={"RadioButton__input-label"}
							htmlFor={`${id}_${index}`}
						>
							{opt.label}
						</Text>
					</div>
				))}
			</div>
		);
	}
}

export default RadioButton;
